import fetch from '../utils/fetch'

export function getServiceTypeOptions(query) {
  return fetch({
    url: '/service/type/options',
    method: 'get',
    params: query
  })
}

export function getServiceSceneList(query) {
  return fetch({
    url: '/service/scene/list',
    method: 'get',
    params: query
  })
}

export function getServiceSceneInfo(query) {
  return fetch({
    url: '/service/scene/info',
    method: 'get',
    params: query
  })
}

export function getEnabledServiceSceneOptions(query) {
  return fetch({
    url: '/service/scene/options',
    method: 'get',
    params: query
  })
}

export function createServiceScene(data) {
  return fetch({
    url: '/service/scene',
    method: 'post',
    data
  })
}

export function updateServiceScene(data) {
  return fetch({
    url: '/service/scene',
    method: 'put',
    params: data
  })
}

export function toggleServiceSceneEnabled(data) {
  return fetch({
    url: '/service/scene/enabled',
    method: 'put',
    params: data
  })
}

export function deleteServiceScene(query) {
  return fetch({
    url: '/service/scene',
    method: 'delete',
    params: query
  })
}

export function copyServiceScene(data) {
  return fetch({
    url: '/service/scene/copy',
    method: 'post',
    data
  })
}

export function exportServiceSceneItems(query) {
  return fetch({
    url: '/service/scene/export',
    method: 'get',
    params: query,
    responseType: 'blob'
  })
}

export function getServiceProductList(query) {
  return fetch({
    url: '/service/product/list',
    method: 'get',
    params: query
  })
}

export function saveServiceProduct(data) {
  return fetch({
    url: '/service/product',
    method: 'post',
    data
  })
}

export function deleteServiceProduct(query) {
  return fetch({
    url: '/service/product',
    method: 'delete',
    params: query
  })
}

export function getServiceContentList(query) {
  return fetch({
    url: '/service/content/list',
    method: 'get',
    params: query
  })
}

export function saveServiceContent(data) {
  return fetch({
    url: '/service/content',
    method: 'post',
    data
  })
}

export function deleteServiceContent(query) {
  return fetch({
    url: '/service/content',
    method: 'delete',
    params: query
  })
}

export function getServiceSceneContentConfig(query) {
  return fetch({
    url: '/service/scene/content/config',
    method: 'get',
    params: query
  })
}

export function saveServiceSceneProductContent(data) {
  return fetch({
    url: '/service/scene/content/save',
    method: 'post',
    data
  })
}
